import React from 'react'
import PropTypes from 'prop-types'
import DNDComponent from "../../../../../gd-modules/dnd/dnd-component"

import DatetimeUtils from "core/gd/utils/datetime-utils"
import UI5CalendarDayDnd from "./day-dnd"

export default class UI5CalendarDay extends DNDComponent {

    static propTypes = {
        data            : PropTypes.object,

        calendarDayDnd  : PropTypes.func,   // special class to override control for drop into calendar days

        onHighlightDate : PropTypes.func,
        onClick         : PropTypes.func,
    }

    static defaultProps = _.assign({}, DNDComponent.defaultProps, {
        dndType: 'target'
    })

    constructor(props) {
        super(props)

        const CalendarDayDnd = props.calendarDayDnd ? props.calendarDayDnd : UI5CalendarDayDnd
        this.dayDnd =  new CalendarDayDnd(props)
    }

    // ----- DND [start] ------
    getDNDId = () => DatetimeUtils.momentToDate(this.props.data.moment)
    getDraggedOverPreviewType() {return 'calendar'}

    canDrop(draggedItem) {return this.dayDnd.canDrop(super.canDrop(draggedItem), draggedItem)}
    onDrop(draggedItem, dropResult) {return this.dayDnd.onDrop(draggedItem, dropResult)}
    // ----- DND [end] ------

    onMouseEnter(e, callback) {
        super.onMouseEnter(e, callback)

        if (this.props.data.isDisabled) return
        if (this.props.onHighlightDate) this.props.onHighlightDate(this.props.data.moment)
    }

    onClick(e) {
        if (this.props.data.isDisabled) return
        if (this.props.onClick) this.props.onClick(this.props.data.moment)
    }

    render() {
        const classes = Classes("day", this.props.data.selectedClasses.join(' '), {
            'another-month'         : !this.props.data.isCurrentMonth,
            'disabled'              : this.props.data.isDisabled,
            'today'                 : this.props.data.isToday,
            'selected'              : this.props.data.isSelected,
            "selected-range"        : this.props.data.inSelectedRange,
            "selected-single"       : this.props.data.isSelectedSingle,
            "selected-start"        : this.props.data.isSelectedStart,
            "selected-end"          : this.props.data.isSelectedEnd,
            "highlight-range"       : this.props.data.isHighlighted,
            "highlight-single"      : this.props.data.isHighlightedSingle,
            "highlight-range-start" : this.props.data.isHighlightedStart,
            "highlight-range-end"   : this.props.data.isHighlightedEnd,
            "highlight-range-edge"  : this.props.data.isHighlightedEdge,
            "is-past"               : this.props.data.isPast,
            "is-future"             : this.props.data.isFuture,
            "weekend"               : this.props.data.isWeekend,

            // -------------------- DND -------------------- //
            'with-dnd-hover'        : !!this.props.dndManager,
            'can-drop'              : !!this.props.dndManager && this.props.dndManager.isDragging() && this.canDrop(this.props.dndManager.getDraggedItem()),
            'is-hover'              : !!this.props.dndManager && this.state.isMouseEntered && !this.props.dndManager.isDragging()
        })

        return <div className={classes}>{this.props.data.label}</div>
    }
}